import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {map} from 'rxjs/operators';

import {TokenService} from '@app/core/services/base/token.service';
import {buildReturnUrlQueryParams} from '@app/features/auth/utils/auth-post-login.util';
import {BootstrapAppService} from '@shared/services/bootstrap-app.service';


@Injectable({
  providedIn: 'root'
})
export class SystemGuard  {

  constructor(
    private _TokenService: TokenService,
    private bootstrapAppService: BootstrapAppService,
    private _Router: Router,
  ) {
  }


  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const returnUrlQueryParams = buildReturnUrlQueryParams(state.url);
    if (this._TokenService.getAccessToken()) {
      return this.bootstrapAppService.storeBootstrapperData().pipe(
        map((shouldAskForPurposes: boolean) => {
          if (shouldAskForPurposes) {
            return this._Router.createUrlTree(['/auth/purpose'], {
              queryParams: returnUrlQueryParams,
            });
          }
          return true;
        }),
      );
    }
    return this._Router.createUrlTree(['/auth'], {
      queryParams: returnUrlQueryParams,
    });
  }
}
